import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../components/header.component";
import "../css/projects.css";

import audioRecorderProjectsData from "../data/projects/audio-recorder.projects.data";
import calculatorProjectsData from "../data/projects/calculator.projects.data";
import chemistryProjectsData from "../data/projects/chemistry.projects.data";
import consoleProjectsData from "../data/projects/console.projects.data";
import davidsimakDevProjectsData from "../data/projects/davidsimak-dev.projects.data";
import devToolsProjectsData from "../data/projects/dev-tools.projects.data";
import formulaSolverProjectsData from "../data/projects/formula-solver.projects.data";
import identityProjectsData from "../data/projects/identity.projects.data";
import noticeBoardProjectsData from "../data/projects/notice-board.projects.data";
import reportingApiProjectsData from "../data/projects/reporting-api.projects.data";
import soundMeterProjectsData from "../data/projects/sound-meter.projects.data";
import reportVisitService from "../reporting-visit/report-visit.service";

import ProjectItem from "./items/project-item.items";

export default class ProjectsPage extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    document.title =
      "Some things I've built | David Šimák - A self-taught JAVA/Kotlin developer";
    window.scrollTo(0, 0);
    reportVisitService.report(window.location.pathname, document.title);
  }

  render() {
    const audioRecorder = audioRecorderProjectsData.getAsItem();
    const calculator = calculatorProjectsData.getAsItem();
    const chemistry = chemistryProjectsData.getAsItem();
    const console = consoleProjectsData.getAsItem();
    const davidsimak = davidsimakDevProjectsData.getAsItem();
    const formula = formulaSolverProjectsData.getAsItem();
    const identity = identityProjectsData.getAsItem();
    const noticeBoard = noticeBoardProjectsData.getAsItem();
    const reporting = reportingApiProjectsData.getAsItem();
    const soundMeter = soundMeterProjectsData.getAsItem();
    const devTools = devToolsProjectsData.getAsItem();
    return (
      <div>
        <Header lightColor={true} />
        <div className="page_title_container">
          <label class="big_title">Some things I've built</label>
        </div>

        <div class="section">
          <ProjectItem item={audioRecorder} />

          <hr
            style={{
              backgroundColor: "#BDBDBD",
              height: "1px",
              border: "0px",
              opacity: 1,
              margin: "40px 0",
            }}
          />
          <ProjectItem item={calculator} />

          <hr
            style={{
              backgroundColor: "#BDBDBD",
              height: "1px",
              border: "0px",
              opacity: 1,
              margin: "40px 0",
            }}
          />
          <ProjectItem item={chemistry} />

          <hr
            style={{
              backgroundColor: "#BDBDBD",
              height: "1px",
              border: "0px",
              opacity: 1,
              margin: "40px 0",
            }}
          />
          <ProjectItem item={console} />

          <hr
            style={{
              backgroundColor: "#BDBDBD",
              height: "1px",
              border: "0px",
              opacity: 1,
              margin: "40px 0",
            }}
          />
          <ProjectItem item={davidsimak} />

          <hr
            style={{
              backgroundColor: "#BDBDBD",
              height: "1px",
              border: "0px",
              opacity: 1,
              margin: "40px 0",
            }}
          />
          <ProjectItem item={devTools} />

          <hr
            style={{
              backgroundColor: "#BDBDBD",
              height: "1px",
              border: "0px",
              opacity: 1,
              margin: "40px 0",
            }}
          />
          <ProjectItem item={formula} />

          <hr
            style={{
              backgroundColor: "#BDBDBD",
              height: "1px",
              border: "0px",
              opacity: 1,
              margin: "40px 0",
            }}
          />
          <ProjectItem item={identity} />

          <hr
            style={{
              backgroundColor: "#BDBDBD",
              height: "1px",
              border: "0px",
              opacity: 1,
              margin: "40px 0",
            }}
          />
          <ProjectItem item={noticeBoard} />

          <hr
            style={{
              backgroundColor: "#BDBDBD",
              height: "1px",
              border: "0px",
              opacity: 1,
              margin: "40px 0",
            }}
          />
          <ProjectItem item={reporting} />

          <hr
            style={{
              backgroundColor: "#BDBDBD",
              height: "1px",
              border: "0px",
              opacity: 1,
              margin: "40px 0",
            }}
          />
          <ProjectItem item={soundMeter} />
        </div>
      </div>
    );
  }
}
